export default [
  'Austria',
  'Belgium',
  'Cyprus',
  'Estonia',
  'Finland',
  'France',
  'French',
  'Germany',
  'Greece',
  'Ireland',
  'Italy',
  'Latvia',
  'Lithuania',
  'Luxembourg',
  'Malta',
  'Netherlands',
  'Curaçao',
  'Sint Maarten',
  'Caribbean Netherlands',
  'Portugal',
  'Slovakia',
  'Slovenia',
  'Spain',
]